import React from "react";
import {
  View,
  Modal,
  StyleSheet,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
} from "react-native";
import color from "@constants/color";
import Cross from "@assets/svg/CrossIcon";
import {
  DeliveryIncentiveModalBody,
  AttendanceIncentiveModalBody,
} from "./PlanModalComponents";

interface Line {
  title: string;
  value: Array<Record<string, string>>;
  key: string;
}

interface PlanModalProps {
  visible: boolean;
  onClose: () => void;
  data?: {
    title: string;
    type: "DELIVERY_INCENTIVE" | "ATTENDANCE_INCENTIVE";
    lines: Array<Line>;
  };
  loading: boolean;
}

const PlanModal: React.FC<PlanModalProps> = ({
  visible,
  onClose,
  data,
  loading,
}) => {
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <TouchableOpacity
        style={styles.modalOverlay}
        activeOpacity={1}
        onPress={onClose}
      >
        {loading ? (
          <ActivityIndicator size="large" color={color.primary} />
        ) : (
          <View style={styles.modalContent}>
            <View style={styles.modalHeader}>
              <View style={styles.modalCross}>
                <TouchableWithoutFeedback onPress={onClose}>
                  <Cross width={16} height={16} />
                </TouchableWithoutFeedback>
              </View>
            </View>

            <View style={styles.modalBody}>
              {data && (
                <View style={{ flex: 1 }}>
                  {data?.type === "DELIVERY_INCENTIVE" ? (
                    <DeliveryIncentiveModalBody
                      title={data?.title}
                      lines={data?.lines}
                    />
                  ) : data?.type === "ATTENDANCE_INCENTIVE" ? (
                    <AttendanceIncentiveModalBody
                      title={data?.title}
                      lines={data?.lines}
                    />
                  ) : null}
                </View>
              )}
            </View>
          </View>
        )}
      </TouchableOpacity>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "stretch",
    position: "relative",
  },
  modalContent: {
    backgroundColor: color.white,
    borderRadius: 20,
    position: "absolute",
    bottom: 0,
    width: "100%",
  },
  modalHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 10,
    paddingHorizontal: 16,
  },
  modalBody: {
    paddingVertical: 6,
    paddingHorizontal: 10,
    // flex: 1,
  },
  modalCross: {
    position: "absolute",
    right: 10,
    top: 10,
    borderRadius: 50,
    zIndex: 1,
    padding: 6,
  },
});

export default PlanModal;
